// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { SettingsCollectionModel } from "@insite/client-framework/Services/SettingsService";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getSettingsCollection as optimizelyGetSettingsCollection } from "@insite/client-framework/Store/Context/ContextSelectors";

interface CustomSettingsCollectionModel extends SettingsCollectionModel {
    customSettings: {
        notFoundLargeImagePath?: string;
        notFoundMediumImagePath?: string;
        notFoundSmallImagePath?: string;
        maxNoOfPagination?: number;
        isAdminAllowedToDeactivateUsers?: boolean;
        siteTimeoutMinutes?: number;
        showStockedItemsOnlyByDefault?: boolean;
    };
}

export function getSettingsCollection(state: ApplicationState): CustomSettingsCollectionModel {
    return optimizelyGetSettingsCollection(state) as CustomSettingsCollectionModel;
}

export function getMaxNoOfPagination(state: ApplicationState): number {
    return getSettingsCollection(state).customSettings.maxNoOfPagination || 10;
}

export function getIsAdminAllowedToDeactivateUsers(state: ApplicationState): boolean {
    return getSettingsCollection(state).customSettings?.isAdminAllowedToDeactivateUsers || false;
}
